import { NextPageContext } from 'next'
import {
  serializeAuth0ClearSessionCookies,
  createAuthPathname,
  AUTH_COOKIES,
} from '@reward-platform/auth0-b2c'
import {
  getCookieBooleanValue,
  getCookiesFromRequest,
  redirectResponse,
  setCookieInResponse,
} from '../utils'
import { isServerPageContext } from './pageContext.utils'
import { getPlatformBasePathFromPageContext } from './platformConfig.handler'

const PATHS_TO_SKIP_SILENT_LOGIN = ['sitemap', '_next', 'assets', 'fonts']

// TODO: move to env var as comma separated string?
const USER_AGENT_KEY_WORDS_TO_SKIP_SILENT_LOGIN = [
  'bot',
  'crawl',
  'slurp',
  'spider',
  'WhatsApp',
  'TelegramBot',
  'Slackbot',
  'Viber',
  'Discordbot',
  'SkypeUriPreview',
  'Lighthouse',
]

// Runs only for page navigation
const shouldRunSilentLoginForPath = (path?: string) => {
  if (!path) {
    return true
  }

  return !PATHS_TO_SKIP_SILENT_LOGIN.some((str) => path.includes(str))
}

// Ignores listed user-agents to allow for Google bots
const shouldRunSilentLoginForUserAgent = (userAgent?: string) => {
  if (!userAgent) {
    return true
  }

  const lowerCaseUserAgent = userAgent.toLowerCase()

  return !USER_AGENT_KEY_WORDS_TO_SKIP_SILENT_LOGIN.some((botUserAgent) =>
    lowerCaseUserAgent.includes(botUserAgent.toLowerCase())
  )
}

export const handleSilentLogin = async (pageContext: NextPageContext) => {
  const isServer = isServerPageContext(pageContext)
  if (!isServer) {
    return
  }
  const hasAlreadyRunSilentLogin = getCookieBooleanValue(
    pageContext.req,
    AUTH_COOKIES.HAS_RUN_SILENT_LOGIN_STATE
  )
  const basePath = getPlatformBasePathFromPageContext(pageContext)

  const shouldAttemptSilentLogin =
    !hasAlreadyRunSilentLogin &&
    shouldRunSilentLoginForPath(pageContext.req.url) &&
    shouldRunSilentLoginForUserAgent(pageContext.req.headers['user-agent'])

  if (shouldAttemptSilentLogin) {
    // Clears other applications appSession cookies, used for keeping header minimal for internal application
    const cookies = getCookiesFromRequest(pageContext.req)
    const clearedSessionCookies = serializeAuth0ClearSessionCookies(cookies)
    setCookieInResponse(pageContext.res, clearedSessionCookies)

    const returnToPath = pageContext.asPath
    const returnToLocale = pageContext.locale
    redirectResponse(
      pageContext.res,
      createAuthPathname('SILENT_LOGIN', { basePath, returnToPath, returnToLocale }),
      302
    )
  }
}
